/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { TicketEditComponent, setupFormForConstraint } from '../ticket-edit.component';
import { TicketEditService } from '../../ticket-edit.service';
import { UntypedFormBuilder } from '@angular/forms';
import { PlanState } from 'src/app/services/plan-state.service';
import { ConstraintAcceptanceService } from '../../constraint-acceptance.service';
import { PlanAccessCheck } from 'src/app/services/PlanAccessCheck';
import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';
import * as strings from '@touchplan/strings';
import {
	DateAdapter,
	MAT_DATE_FORMATS,
	MAT_NATIVE_DATE_FORMATS,
	NativeDateAdapter,
} from '@angular/material/core';

@Component({
	selector: 'multi-edit-constraint',
	templateUrl: './multi-edit-constraint.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	// Use the native date adapter here vs our custom Iso8601DateAdapter
	// (Won't be refactored yet since this will be replaced by Docked ticket editing.)
	providers: [
		{ provide: MAT_DATE_FORMATS, useValue: MAT_NATIVE_DATE_FORMATS },
		{ provide: DateAdapter, useClass: NativeDateAdapter },
	],
})
export class MultiEditConstraintComponent extends TicketEditComponent implements OnInit {
	public appStrings = strings;
	constructor(
		protected override ticketEditService: TicketEditService,
		protected override formBuilder: UntypedFormBuilder,
		protected override planState: PlanState,
		protected override cd: ChangeDetectorRef,
		protected override constraintAcceptanceService: ConstraintAcceptanceService,
		protected override planAccessCheck: PlanAccessCheck,
		protected override featureFlagManager: FeatureFlagManager
	) {
		super(
			ticketEditService,
			formBuilder,
			planState,
			cd,
			constraintAcceptanceService,
			planAccessCheck,
			featureFlagManager
		);
		setupFormForConstraint(this.editForm);
	}

	public override ngOnInit() {
		super.ngOnInit();
	}

	public requestedByChanged(newRequestedByProjectMemberId: string): void {
		this.constraintAcceptanceService.setRequestedByProjectMemberId(this.data, newRequestedByProjectMemberId);
	}

	public assignedToChanged(newAssignedProjectMemberId: string) {
		this.constraintAcceptanceService.setAssignedProjectMember(this.data, newAssignedProjectMemberId, true);
	}
}
